import React from 'react';

export const LeftArrow = (): JSX.Element => {
  return (
    <svg xmlns="http://www.w3.org/2000/svg" width="9" height="14" viewBox="0 0 9 14">
      <g fill="none" fillRule="evenodd" strokeLinecap="round" strokeLinejoin="round">
        <g stroke="#aaaaaa" strokeWidth="2.5">
          <path
            d="M54.173 103.827L59.423 108.673 64.673 103.827"
            transform="translate(-55.000000, -99.000000) translate(59.423077, 106.250000) scale(-1, 1) rotate(-90.000000) translate(-59.423077, -106.250000)"
          />
        </g>
      </g>
    </svg>
  );
};

export const RightArrow = (): JSX.Element => {
  return (
    <svg xmlns="http://www.w3.org/2000/svg" width="9" height="14" viewBox="0 0 9 14">
      <g fill="none" fillRule="evenodd" strokeLinecap="round" strokeLinejoin="round">
        <g stroke="#aaaaaa" strokeWidth="2.5">
          <path
            d="M54.173 103.827L59.423 108.673 64.673 103.827"
            transform="translate(-55.000000, -99.000000) translate(59.423077, 106.250000) scale(-1, 1) rotate(-270.000000) translate(-59.423077, -106.250000)"
          />
        </g>
      </g>
    </svg>
  );
};

export const VerbsArrow = ({ side = 'right' }: { side: string }): JSX.Element => {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="8"
      height="12"
      viewBox="0 0 8 12"
      fill="none"
      transform={side == 'left' ? 'rotate(180)' : ''}
    >
      <path d="M1 1.59 6.947 6 1 10.41" stroke="#000" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round" />
    </svg>
  );
};

export const LeftArrowIcon = (): JSX.Element => {
  return (
    <svg xmlns="http://www.w3.org/2000/svg" width="44" height="44" viewBox="0 0 44 44" fill="none">
      <g>
        <path
          fillRule="evenodd"
          clipRule="evenodd"
          d="M26.968 29.113 19.855 22l7.113-7.113a1.826 1.826 0 0 0 0-2.585 1.826 1.826 0 0 0-2.585 0l-8.415 8.415a1.826 1.826 0 0 0 0 2.585l8.415 8.415c.715.715 1.87.715 2.585 0 .697-.715.715-1.889 0-2.604z"
          fill="#006298"
        />
        <mask
          id="8yy4dcl4ba"
          style={{ maskType: 'alpha' }}
          maskUnits="userSpaceOnUse"
          x="15"
          y="11"
          width="13"
          height="22"
        >
          <path
            fillRule="evenodd"
            clipRule="evenodd"
            d="M26.968 29.113 19.855 22l7.113-7.113a1.826 1.826 0 0 0 0-2.585 1.826 1.826 0 0 0-2.585 0l-8.415 8.415a1.826 1.826 0 0 0 0 2.585l8.415 8.415c.715.715 1.87.715 2.585 0 .697-.715.715-1.889 0-2.604z"
            fill="#fff"
          />
        </mask>
      </g>
    </svg>
  );
};

export const RightArrowIcon = (): JSX.Element => {
  return (
    <svg xmlns="http://www.w3.org/2000/svg" width="44" height="44" viewBox="0 0 44 44" fill="none">
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M17.031 14.887 24.145 22l-7.114 7.113a1.826 1.826 0 0 0 0 2.585c.715.715 1.87.715 2.585 0l8.415-8.415a1.826 1.826 0 0 0 0-2.585l-8.415-8.415a1.826 1.826 0 0 0-2.585 0c-.697.715-.715 1.889 0 2.604z"
        fill="#006298"
      />
      <mask
        id="r285jykbja"
        style={{ maskType: 'alpha' }}
        maskUnits="userSpaceOnUse"
        x="16"
        y="11"
        width="13"
        height="22"
      >
        <path
          fillRule="evenodd"
          clipRule="evenodd"
          d="M17.031 14.887 24.145 22l-7.114 7.113a1.826 1.826 0 0 0 0 2.585c.715.715 1.87.715 2.585 0l8.415-8.415a1.826 1.826 0 0 0 0-2.585l-8.415-8.415a1.826 1.826 0 0 0-2.585 0c-.697.715-.715 1.889 0 2.604z"
          fill="#fff"
        />
      </mask>
    </svg>
  );
};
